export default function isPricingDetailsHidden(){
  return process.env.REACT_APP_PRICING_DETAILS_HIDDEN === '1'
}